import { format, isValid } from 'date-fns';
import { de } from 'date-fns/locale/de';
import { enUS } from 'date-fns/locale/en-US';
import { fr } from 'date-fns/locale/fr';
import { it } from 'date-fns/locale/it';
import { toDayKey } from './rome-date';

// Only the four site languages, each locale imported on its own path so the bundle carries
// just these four.
const LOCALES = { en: enUS, it, de, fr };

// Shown for an invalid date; date-fns format() would throw
export const INVALID_DATE = 'Invalid date';

/** Formats a date (date-fns pattern tokens); 'Invalid date' when it is invalid. */
export function formatDate(date: Date, pattern: string) {
  return isValid(date) ? format(date, pattern) : INVALID_DATE;
}

/** 'yyyy-MM-dd' local day of a picked date, for API payloads; 'Invalid date' if missing. */
export function dayKeyOrInvalid(date: Date | null | undefined) {
  return toDayKey(date) ?? INVALID_DATE;
}

/** Formats a date in the site language; 'Invalid date' when it is invalid. */
export function formatInLanguage(date: Date, pattern: string, lang: string) {
  return isValid(date)
    ? format(date, pattern, {
        locale: LOCALES[lang as keyof typeof LOCALES] ?? enUS,
      })
    : INVALID_DATE;
}

/** Local Date with the UTC calendar fields of a date, to format it as UTC. */
export function utcAsLocal(date: Date) {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
    date.getUTCMilliseconds(),
  );
}
